import * as React from 'react';
import './Popper.scss';

const PopperTitle = () => (<div className="Popper Popper-title">
	<div className="Popper-name">
		Empresas
	</div>
	<div className="Popper-total">
		Total Kton
	</div>
	<div className="Popper-branchs">
		Faenas
	</div>
	<div className="Popper-branchs-total">
		Total Kton
	</div>
</div>);

export default PopperTitle;
